module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.NewsLetterSubscriber":{"handleDom.focus.target":[{"value":"input","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleDom.focus.event":[{"value":"focus","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleDom.focus.callback":[{"value":function (el) {
var $el = $(el);
if ($el.length) {
$el.parent().removeClass('error').next().text('').removeClass('show');
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.event":[{"value":"formNotValid","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.widget":[{"value":"#form #validator","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.callback":[{"value":function (data) {
fox.each(data.errorStack, function (v, field) {
var $el = $(this.dom1('[name="' + field + '"]'));
if ($el.length) {
$el.parent().next().text(v[0].message);
}
}, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107022},"path":"~.NewsLetterSubscriber","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/newsLetterSubscriber.js
// module id = 1006
// module chunks = 4